var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2843 14.2156C15.4252 14.3578 15.5042 14.5498 15.5042 14.75C15.5042 14.9501 15.4252 15.1422 15.2843 15.2843C15.141 15.423 14.9494 15.5004 14.7499 15.5004C14.5505 15.5004 14.3589 15.423 14.2156 15.2843L7.99995 9.05935L1.78432 15.2843C1.64097 15.423 1.44936 15.5004 1.24995 15.5004C1.05054 15.5004 0.858927 15.423 0.715571 15.2843C0.574735 15.1422 0.495728 14.9501 0.495728 14.75C0.495728 14.5498 0.574735 14.3578 0.715571 14.2156L6.94057 7.99997L0.715571 1.78435C0.595974 1.63862 0.534855 1.45363 0.544103 1.26534C0.55335 1.07705 0.632303 0.89893 0.765604 0.765629C0.898905 0.632328 1.07702 0.553375 1.26531 0.544128C1.4536 0.53488 1.6386 0.595999 1.78432 0.715596L7.99995 6.9406L14.2156 0.715596C14.3613 0.595999 14.5463 0.53488 14.7346 0.544128C14.9229 0.553375 15.101 0.632328 15.2343 0.765629C15.3676 0.89893 15.4465 1.07705 15.4558 1.26534C15.465 1.45363 15.4039 1.63862 15.2843 1.78435L9.05932 7.99997L15.2843 14.2156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkIcon);
export default __webpack_public_path__ + "static/media/xMarkIcon.ff12f65e93d58dc0be66b798b0469a51.svg";
export { ForwardRef as ReactComponent };